import { ReactElement } from 'react';

import Discord from '@/common/icons/generated/socials/Discord';
import Facebook from '@/common/icons/generated/socials/Facebook';
import Instagram from '@/common/icons/generated/socials/Instagram';
import Pinterest from '@/common/icons/generated/socials/Pinterest';
import Reddit from '@/common/icons/generated/socials/Reddit';
import TikTok from '@/common/icons/generated/socials/Tiktok';
import Twitter from '@/common/icons/generated/socials/Twitter';

import styles from './Referrals.module.scss';

interface SocialLink {
  name: string;
  url: string;
  icons: (props: React.SVGProps<SVGSVGElement>) => ReactElement;
}

const ReferralsSocials = () => {
  const socialLinks: SocialLink[] = [
    { name: 'Reddit', url: 'https://www.reddit.com/r/Displate/', icons: Reddit },
    { name: 'Discord', url: 'https://www.discord.gg/displate', icons: Discord },
    {
      name: 'Instagram',
      url: 'https://www.instagram.com/displate',
      icons: Instagram,
    },
    { name: 'Facebook', url: 'https://www.facebook.com/displate', icons: Facebook },
    { name: 'Pinterest', url: 'https://pinterest.com/displate/', icons: Pinterest },
    { name: 'Twitter', url: 'https://www.twitter.com/Displate', icons: Twitter },
    { name: 'TikTok', url: 'https://www.tiktok.com/@displate', icons: TikTok },
  ];

  return (
    <div className={styles.socialsContainer}>
      <h3 className={styles.socialsTitle}>Join our Community on</h3>
      <div className={styles.socialLinks}>
        {socialLinks.map((link) => (
          <a
            className={styles.socialLink}
            href={link.url}
            key={link.name}
            rel="noopener noreferrer"
            target="_blank"
          >
            <link.icons height={48} width={48} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default ReferralsSocials;
